import React, { useState } from "react";
// api gére les requetes vers l'api avec axios et la variable d'environnement;
import api from "../../api";
import { Navigate } from "react-router-dom";
import UseTitle from "../../components/useTitle";
import "./SkillTemplateDelete.scss";

const SkillTemplateDelete = ({ skillTemplate, setIsDelete }) => {
  // Définition du titre de la page
  UseTitle("Suppression de la compétence " + (skillTemplate?.name || ""));

  const [redirectTo, setRedirectTo] = useState();

  const handleDelete = () => {
    api
      .delete(`/skilltemplate/${skillTemplate.id}/`)
      .then((response) => {
        console.log(response.data);
        setRedirectTo(`/skill`);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (redirectTo) {
    return <Navigate to={redirectTo} replace={true} />;
  }

  return (
    <>
      <div className="skill-template-delete">
        <h2>
          Etes-vous sur de vouloir définitivement supprimer la compétence :{" "}
          {skillTemplate.name} ?
        </h2>
        <div className="buttons">
          <button className="bt" onClick={handleDelete}>
            Oui
          </button>
          <button className="bt" onClick={() => setIsDelete(false)}>
            Non
          </button>
        </div>
      </div>
    </>
  );
};

export default SkillTemplateDelete;
